/**
 * Stable CSS class names for E2E — Force password reset bulk entry page.
 */
export const CPWC = {
    page: 'customer-password-change-page',
    breadcrumbRow: 'customer-password-change-page__breadcrumb-row',
    fieldSearchMode: 'customer-password-change-field--search-mode',
    inputRadioGroupSearchMode: 'customer-password-change-input--radio-group-search-mode',
    inputRadioOptionEmail: 'customer-password-change-input--radio-option-email',
    inputRadioOptionPhone: 'customer-password-change-input--radio-option-phone',
    editorWrap: 'customer-password-change-page__editor-wrap',
    lineNumbersColumn: 'customer-password-change-page__line-numbers-column',
    inputBulkLines: 'customer-password-change-input--bulk-lines',
    actionsRow: 'customer-password-change-page__actions-row',
    inputButtonClear: 'customer-password-change-input--button-clear',
    inputButtonSubmit: 'customer-password-change-input--button-submit',
} as const;

export const cpwcCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
